// API Configuration - Centralized API URL
// Uses REACT_APP_BACKEND_URL from environment

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${API_BASE_URL}/api`;

export default API;
